import ApiConstant from "../../constants/api.constants";
import LocalStorageConstant from "../../constants/localstroage.constant";
import api from "../api";
import Helpers from "../../utils/helpers";
import { UserModel } from "../../models/user-model";

const getCurrentUser = async () => {
  try {
    return await api
      .get(ApiConstant.getUser, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          var userDetails = JSON.stringify(response.data);
          localStorage.setItem(LocalStorageConstant.user, userDetails);
          return response.data;
        }
        return null;
      })
      .catch(function (error) {
        Helpers.ConsoleLogError(error);
        return null;
      });
  }
  catch
  {
    console.log('error in get current user');
  }
  return null;


};

const getUserById = async (userId: number) => {

  try {
    return await api
      .get(Helpers.formatString(ApiConstant.getUserById, userId), {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  }
  catch
  {
    console.log('error in get current user');
  }
};

const updateUserProfile = async (user: UserModel, otp?: string) => {

  try {

    var otpParam = otp ? "?otp=" + otp : "";
    return await api
      .put(ApiConstant.updateUser + otpParam, user, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  }
  catch
  {
    console.log('error in get current user');
  }
};

const getUserRoles = async (userID: number) => {
    try {
        const response = await api.post(ApiConstant.GetRolesByUserid, { userID });
        const data = response.data;
        console.log("Assigned Roles:", data.assignedRoles);
        console.log("Unassigned Roles:", data.unassignedRoles);
        return data;
    } catch (error) {
        console.error("Error fetching roles", error);
        return null;
    }
};

export const assignUserRole = async (roleData: {
    userId: number;
    roleId: number;
    isActive: boolean;
}) => {
    try {
        const response = await api.post(ApiConstant.Assigningtherole, roleData);
        return {
            isSuccess: true,
            ...response.data
        };
    } catch (error) {
        console.error('Error assigning role', error);
        return { isSuccess: false };
    }
};

const CreateRole = async (roleData: any) => {
  try {
    const response = await api.post(ApiConstant.CreateRole, roleData);
    return response.data;
  } catch (error: any) {
    return error.response?.data || { 
      isSuccess: false, 
      message: "An error occurred while creating role" 
    };
  }
};

const GetAllRoles = async () => {
  try {
    const response = await api.get(ApiConstant.GetAllRole);
    return response?.data || [];
  } catch (error) {
    console.error('Error getting all roles:', error);
    return [];
  }
};

const UpdateRole = async (roleData: {
  roleID: number;
  name: string;
  description: string;
}) => {
  try {
    const response = await api.put(ApiConstant.UpdateRole, roleData);
    return response.data; 
  } catch (error: any) {
    return error.response?.data || { 
      isSuccess: false, 
      message: "An error occurred while updating role" 
    };
  }
};

const DeleteRole = async (roleID: number) => {
  try {
    const response = await api.delete(`${ApiConstant.DeleteRole}${roleID}`);
    return response?.data || { isSuccess: false, message: "Failed to delete role" };
  } catch (error: any) {
    return { 
      isSuccess: false, 
      message: error.response?.data?.message || "An error occurred while deleting role" 
    };
  }
};

const GetAllDomain = async () => {
  try {
    const response = await api.get(ApiConstant.GetAllDomain);
    return response?.data || [];
  } catch (error) {
    console.error('Error getting all Domains:', error);
    return [];
  }
};

  const GetfeatureBYDomainId = async (domainId: number) => {
    try {
      const response = await api.get(`${ApiConstant.GetAllFeatureByDomainID}/${domainId}`);
      return response?.data || [];
    } catch (error) {
      console.error('Error getting features by Domain ID:', error);
      return { features: [] }; ;
    }
  };

    const GetAllFeatureByRole = async (roleId : number) => {
    try {
      const response = await api.get(`${ApiConstant.GetFeatureByRoleID}/${roleId }`);
      return response?.data || [];
    } catch (error) {
      console.error('Error getting features by role ID:', error);
      return []; 
    }
  };

  const CreateOrUpdateFeatureMapping = async(Data: {
    roleID: number;
    userID: number;
    featureID: number;
    isActive: boolean;
}) => {
  try {
    const response = await api.post(ApiConstant.CreateandupdateFeatureMapping, Data);
    return response?.data || { isSuccess: false, message: 'Unexpected error' };
  } catch (error) {
    console.error('Error in CreateOrUpdateFeatureMapping:', error);
    return {
      isSuccess: false,
      message: 'Failed to update feature access. Please try again later.'
    };
  }
};



const UserService = {
  getUserById,
  getCurrentUser,
  updateUserProfile,
  getUserRoles,
  assignUserRole,
  GetAllRoles,
  UpdateRole,
  DeleteRole,
  CreateRole,
  GetAllDomain,
  GetfeatureBYDomainId,
  GetAllFeatureByRole,
  CreateOrUpdateFeatureMapping
};

export default UserService;